@if (company) {
  <!-- Content to display if company is present -->
  <ng-template
    [ngTemplateOutlet]="commonTemplate"
  [ngTemplateOutletContext]="{ $implicit: company }"></ng-template>
} @else {
  @if (companyHeader(); as companyHeader) {
    <!-- Content to display if companyHeader() resolve e há dado presente -->
    <ng-template
      [ngTemplateOutlet]="commonTemplate"
    [ngTemplateOutletContext]="{ $implicit: companyHeader }"></ng-template>
  }
}


<!-- Company -->
<ng-template
  #commonTemplate
  let-company>
  <div
    class="grid auto-cols-max grid-flow-col gap-x-8 -mr-8 py-4 px-8 rounded-l-2xl print:-mr-0"
    [ngStyle]="{'color': company?.textColor, 'backgroundColor': company?.backgroundColor}"
    [ngClass]="{'text-white': !company?.textColor, 'bg-accent dark:bg-hover dark:print:bg-accent': !company?.backgroundColor}">

    <div class="text-md">
      <div class="text-xl font-medium">{{ company?.name }}</div>

      <!-- Company Address -->
      @if (company.address) {
        <div>
          {{ company?.address?.street }},
          {{ company?.address?.number }}
        </div>
        <div>
          {{ company?.address?.neighborhood }},
          {{ company?.address?.city }} - {{ company?.address?.state }}
        </div>
      }

      <div>{{ company?.phone }}</div>
      <div>{{ company?.email }}</div>
    </div>

    @if (company?.logo) {
      <div
        class="place-self-center w-30 pl-8 border-l"
        >
        <img
          class="w-30"
          alt="logo"
          [src]="company.logo">
      </div>
    }
  </div>
</ng-template>
